import { useScript } from '../use-script/use-script.hooks';

export enum EcoRebatesWidgetTypes {
	PRODUCT,
	REBATE_CENTER
}

const EcoRebatesScripts: Record<EcoRebatesWidgetTypes, string> = {
	[EcoRebatesWidgetTypes.PRODUCT]: 'https://static.ecorebates.com/widgets/build/product.js',
	[EcoRebatesWidgetTypes.REBATE_CENTER]: 'https://static.ecorebates.com/widgets/build/widgets.js'
};

export const useGetEcoRebatesWidgetScript = (type: EcoRebatesWidgetTypes) => {
	useScript({
		src: EcoRebatesScripts[type],
		async: true
	});
};
